import {useCallback} from 'react'

import useApiQuery from '$hooks/insurance/useApiQuery'
import {getConnectExpiresQuery} from '$queries/connect/connectQuery'
import {getOrganizationExpirationInfo} from '$utils/insurance'

import type {GetExpireStatusParams} from '$constants/api-infos'

const useMyDataExpirationQuery = (
    {includeConsents, includeExt}: GetExpireStatusParams = {
        includeConsents: true,
        includeExt: false,
    },
    queryOptions: {
        enabled: boolean
    } = {
        enabled: true,
    },
) => {
    const {data: expiresData, isFetched: isConnectExpiresFetched} = useApiQuery({
        ...getConnectExpiresQuery.query({
            params: {includeConsents, includeExt},
        }),
        ...queryOptions,
    })

    const checkOrgExpired = useCallback(
        (orgCode: string) => {
            return expiresData ? getOrganizationExpirationInfo({orgCode, expiresData}).expired : false
        },
        [expiresData],
    )

    return {
        checkOrgExpired,
        expiresData,
        isConnectExpiresFetched,
    }
}

export default useMyDataExpirationQuery
